module.exports = __webpack_public_path__ + "static/media/Experience.499a1b39.svg";